import { Company } from "@finway-group/shared/lib/models"
import { SortEnum } from "Features/settings/companySettings/companyList"
import stringSimilarity from "string-similarity"

export const sortCompanyByName = (companyA: Company, companyB: Company) => companyA.name.localeCompare(companyB.name)

export const sortCompaniesByName = (companies: Company[], sort = SortEnum.DESC) => {
    const sorted = [...companies].sort(sortCompanyByName)
    return sort === SortEnum.DESC ? sorted.reverse() : sorted
}

export const sortCompaniesByCreatedAt = (companies: Company[], sort = SortEnum.DESC) => {
    const sorted = [...companies].sort((companyA: any, companyB: any) => new Date(companyA?.createdAt)?.getTime() - new Date(companyB?.createdAt)?.getTime())
    return sort === SortEnum.DESC ? sorted.reverse() : sorted
}

export const searchCompanies = (search: string, companies: Company[]) => {
    if (search.trim() === "") return companies
    return companies.filter(
        (company) =>
            stringSimilarity.compareTwoStrings(company?.name?.toLocaleLowerCase()?.trim() || "", search?.toLocaleLowerCase()?.trim()) > 0.6 || company.name.includes(search)
    )
}
